// src/components/NotFoundState.js
//
// Kayıt bulunamadığında gösterilen ortak ekran. Önceden IsEmriDetay çıplak
// "İş Emri Bulunamadı." metni basıyordu: kullanıcı ne olduğunu ve nereye
// döneceğini anlamıyordu (silinmiş iş emrine giden ölü bildirim linkleri
// doğrudan bu ekrana düşüyor).

import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Paper, Typography, Button, Stack } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';

const NotFoundState = ({
    title = 'Kayıt bulunamadı',
    id,
    description = 'Aradığınız kayıt silinmiş olabilir.',
    backTo = '/dashboard',
    backLabel = 'Listeye Dön',
    children
}) => (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
        <Paper sx={{ p: 4, maxWidth: 520, width: '100%', textAlign: 'center' }}>
            <SearchOffIcon color="disabled" sx={{ fontSize: 56, mb: 1 }} />
            <Typography variant="h5" gutterBottom>{title}</Typography>
            <Typography variant="body2" color="text.secondary">{description}</Typography>
            {id && (
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, fontFamily: 'monospace' }}>
                    Kayıt no: {id}
                </Typography>
            )}
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="center" sx={{ mt: 3 }}>
                <Button variant="contained" component={RouterLink} to={backTo}>{backLabel}</Button>
                {children}
            </Stack>
        </Paper>
    </Box>
);

export default NotFoundState;
